import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { parseQueryString } from '@zg-rentals/string-utils';
import PropertyDetailsPage from './component';
import { AppSelectors, RouterSelectors, UserSelectors } from '@rental-manager/selectors';
import PropertiesActions from '@rental-manager/actions/PropertiesActions';
import StaticMapActions from '@rental-manager/actions/StaticMapActions';
import { getIreneDashboard } from '@rental-manager/actions/requests';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { closeNotification, showPageNotification } from '@common/actions/NotificationActions';
import { checkRequestActionSuccess } from '@common/paymentsUtils/api';
import { saveEncodedLeaseId } from '@rental-manager/actions/OnboardingActions';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, ownProps) => ({
  fromAggregateView: parseQueryString(ownProps.location.search).fromWhere === 'aggregateView',
  hostname: AppSelectors.makeHostname(state),
  location: RouterSelectors.makeLocation(state),
  propertyId: ownProps.match.params.propertyId,
  encodedLeaseId: queryString.parse(ownProps.location.search).leaseId,
  router: RouterSelectors.makeRouter(state),
  search: RouterSelectors.makeSearch(state),
  prevPath: AppSelectors.makePrevPath(state),
  propertyStore: state.payments.landlord.property,
  onboarding: state.payments.landlord.onboarding,
  config: state.payments.landlord.config,
  cookieEnabledServices: AppSelectors.makeCookieEnabledServices(state),
  clusterSettings: AppSelectors.makeclusterSettings(state),
  user: UserSelectors.makeUser(state),
});

const mapDispatchToProps = (dispatch) => ({
  getListing: async (propertyId) => {
    try {
      const response = await dispatch(PropertiesActions.getDetails(propertyId));
      await checkRequestActionSuccess(response);
      dispatch(PropertiesActions.saveListingAlias(response.listingAlias));
      dispatch(PropertiesActions.saveListingDetails(response));
      return response;
    } catch (err) {
      logError({ error: err });
      return { error: true };
    }
  },
  getIreneDashboard: async (propertyId, encodedLeaseId) => {
    try {
      await dispatch(closeNotification());
      const [response1] = await dispatch(getIreneDashboard({ propertyId, encodedLeaseId }));
      await checkRequestActionSuccess(response1);
      if (encodedLeaseId) {
        await dispatch(saveEncodedLeaseId({ propertyId, encodedLeaseId }));
      }
    } catch (err) {
      logError({ error: err });
      await dispatch(showPageNotification(DEFAULT_ERROR));
      return { error: true };
    }
  },
  signUrl: async (url, params) => dispatch(StaticMapActions.signUrl(url, params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PropertyDetailsPage));
